type SentryQueryMeta = {
  sentry?: {
    ignoreStatuses?: number[];
  };
};

const getErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") return undefined;
  const status = (error as { status?: unknown }).status;
  return typeof status === "number" ? status : undefined;
};

const getErrorCode = (error: unknown): string | undefined => {
  if (!error || typeof error !== "object") return undefined;
  const code = (error as { code?: unknown }).code;
  return typeof code === "string" ? code : undefined;
};

export const shouldReportReactQueryError = (error: unknown, meta: unknown): boolean => {
  const status = getErrorStatus(error);
  const code = getErrorCode(error);
  const ignoreStatuses = (meta as SentryQueryMeta | undefined)?.sentry?.ignoreStatuses ?? [];

  if (status === 429 && code === "RATE_LIMITED") {
    return false;
  }

  if (status !== undefined && ignoreStatuses.includes(status)) {
    return false;
  }

  return true;
};
